export default "__VITE_ASSET__CODpOYhT__"